var $ = require('jquery');

$(document).ready(function() {
    initTable();
})
function initTable() {
    var scroll = '<span class="wp-element-scroll">Scroll <i class="ph-light ph-arrow-right"></i></span>';
    $('.page-section--main .wp-block-group > table').wrap('<figure class="wp-block-table"></figure>');
    $('.page-section--main .wp-block-table table').wrap('<div class="wp-block-table__inner-container"></div>');

    $('.wp-block-table').each(function(){
        var figacaptionLength = $(this).find('.wp-element-caption');

        if(figacaptionLength.length != 0 ) {
            var figacaption = $(this).find('.wp-element-caption');
            figacaption.wrap('<div class="wp-block-table__inner-container"></div>');
            $(scroll).insertAfter(figacaption);
        } else  {
            $(scroll).insertAfter($(this).find('.wp-block-table__inner-container'));
            $(this).find('.wp-element-scroll').wrap('<div class="wp-block-table__inner-container"></div>');
        }
    });
}
